<template>
  <div class="fee-manage">
    <div class="row">
      <div class="col">
        <div class="card shadow">
          <div class="card-body">
            <div style="min-height: 77vh;">
              <div v-if="mode ==='list'">
                <ManageFeeSeason
                    :mode="mode"
                    :selectedRow="selectedRow"
                    @change-mode="mode=$event"
                    @select-row="selectedRow=$event"/>
              </div>
              <div v-if="mode ==='create' || mode ==='update'">
                <ManageFeeInputForm
                    :mode="mode"
                    :selectedRow="selectedRow"
                    @change-mode="mode=$event"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>



</template>

<script>

import ManageFeeSeason from "@/views/pages/manage/manageFeeSeason.vue";
import ManageFeeInputForm from "@/views/pages/manage/manageFeeInputForm.vue";


export default {
  name: "ManageFee",
  components: { ManageFeeSeason, ManageFeeInputForm },
  data() {
    return {
      mode : 'list',
      selectedRow: null,
    }
  },
  methods: {

  },
}
</script>

<style>

</style>